<div class="content">
  <span class="mat-title"> Suas informações pessoais</span>

  <form [formGroup]="form" (submit)="submit()" autocomplete="off">
    <div class="actions" style="padding: 10px; flex-direction: row">
      <button mat-stroked-button color="primary" type="button" (click)="editable()" *ngIf="!formEditable">
        <mat-icon>edit</mat-icon>
        Editar
      </button>
      <button mat-stroked-button color="warn" type="button" (click)="editable(false)" *ngIf="formEditable">
        <mat-icon>close</mat-icon>
        Cancelar
      </button>
      <!-- <button mat-raised-button class="custom-primary" type="submit" [disabled]="form.pristine">Atualizar</button> -->
      <button mat-raised-button color="warn" (click)="excluir_conta()" type="button">
        <mat-icon>delete_forever</mat-icon>
        Excluir Conta
      </button>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Primeiro nome</mat-label>
        <input type="text" placeholder="Seu primeiro nome" matInput formControlName="firstname"
          [readonly]="!formEditable" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Sobrenome nome</mat-label>
        <input type="text" placeholder="Seu sobrenome" matInput formControlName="lastname" [readonly]="!formEditable" />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input type="email" placeholder="Seu email" matInput formControlName="email" [readonly]="true"
          disabled="disabled" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>CPF</mat-label>
        <input matInput type="text" placeholder="Informe seu cpf" mask="000.000.000-00" required formControlName="cpf"
          [readonly]="!formEditable" inputmode="numeric" />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Celular</mat-label>
        <input matInput type="phone" placeholder="Informe seu numero de telefone" mask="(00) 00000 0000"
          formControlName="phone" inputmode="numeric" [readonly]="!formEditable" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Whatspp</mat-label>
        <input matInput type="mobile" placeholder="Informe seu numero do whatsapp" mask="(00) 00000 0000"
          formControlName="mobile" inputmode="numeric" [readonly]="!formEditable" />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Sexo</mat-label>
        <mat-select matInput required placeholder="Informe seu sexo" formControlName="gender"
          [disabled]="!formEditable">
          <mat-option value="feminino">Feminino</mat-option>
          <mat-option value="masculino">Masculino</mat-option>
          <mat-option value="outros">Outros</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Data de nascimento</mat-label>
        <input matInput type="text" mask="00/00/0000" inputmode="numeric" placeholder="Informe sua data de nascimento"
          formControlName="birthday" [readonly]="!formEditable" />
      </mat-form-field>
    </div>

    <fieldset>
      <legend>Endereço</legend>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>CEP</mat-label>
          <input matInput type="text" placeholder="Informe seu cep" mask="00.000-000" formControlName="zipCode"
            inputmode="numeric" [readonly]="!formEditable" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Estado</mat-label>
          <!--<mat-select matInput placeholder="Informe seu estado" formControlName="state" [disabled]="!formEditable">
                        <ng-container *ngFor="let state of states">
                            <mat-option [value]="state.sigla">{{ state.nome }}</mat-option>
                        </ng-container>
                    </mat-select>-->
          <input matInput type="text" placeholder="Informe seu estado" formControlName="state"
            [readonly]="!formEditable" [matAutocomplete]="autoState" />
          <mat-autocomplete #autoState="matAutocomplete">
            <ng-container *ngFor="let state of filteredStates$ | async">
              <mat-option [value]="state.nome">{{ state.nome }}</mat-option>
            </ng-container>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Cidade</mat-label>
          <input matInput type="text" placeholder="Informe sua cidade" formControlName="city"
            [readonly]="!formEditable" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Bairro</mat-label>
          <input matInput type="text" placeholder="Informe seu bairro" formControlName="district"
            [readonly]="!formEditable" />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Rua/avenida</mat-label>
          <input matInput type="text" placeholder="Informe a rua/avenida" formControlName="street"
            [readonly]="!formEditable" />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Numero de residência</mat-label>
          <input matInput type="text" placeholder="Informe numero da sua residência" formControlName="number"
            inputmode="numeric" [readonly]="!formEditable" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Complemento</mat-label>
          <input matInput type="text" placeholder="Informe o complemento" formControlName="complement"
            [readonly]="!formEditable" />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Fale sobre você</mat-label>
          <textarea matInput placeholder="conte-nos um pouco mais sobre você e seus objetivos" formControlName="aboutme"
            rows="10" maxlength="1000" [readonly]="!formEditable"></textarea>
          <mat-hint>Informe até 1000 caracteres</mat-hint>
          <mat-error *ngIf="form.get('aboutme').errors?.required">Por favor preencher o campo</mat-error>
          <mat-error *ngIf="form.get('aboutme').errors?.maxlength">Por favor informe no máximo 1000
            caracteres</mat-error>
        </mat-form-field>
      </div>

      <div class="actions">
        <button mat-raised-button class="custom-primary" type="submit" [disabled]="form.pristine">
          Atualizar
        </button>
      </div>
    </fieldset>
  </form>
</div>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>
